import { AssetGraphPoint, AssetsGraphData, AssetsGraphDataDual, AssetsHistory, TimeFilter } from "@/types";
import { Duration } from "date-fns";
import sub from "date-fns/sub";

export function getDateRange(filter: TimeFilter, dateTo = new Date()): [Date, Date] {
	let duration = (null as unknown) as Duration;

	switch (filter) {
		case TimeFilter.WEEK:
			duration = { weeks: 1 };
			break;

		case TimeFilter.WEEKS_2:
			duration = { weeks: 2 };
			break;

		case TimeFilter.MONTH:
			duration = { months: 36 };
			break;

		case TimeFilter.MONTHS_3:
			duration = { months: 60 };
			break;

		case TimeFilter.YEAR:
			duration = { years: 10 };
			break;
	}

	const dateFrom = sub(dateTo, duration);
	return [dateFrom, dateTo];
}

export function assetsHistoryToChartData(history: AssetsHistory[]): AssetsGraphData {
	const labels = [] as string[];
	const data = [] as number[];

	history.forEach(({ date, amount }) => {
		labels.push(new Date(date).toLocaleDateString());
		data.push(amount);
	});

	return { labels, data };
}

export function assetsHistoryToChartDataDual(history: AssetsHistory[]): AssetsGraphDataDual {
	const labels = [] as string[];
	const data = [] as number[];
	const summaryData = [] as number[];

	history.forEach(({ date, amount, summary }) => {
		labels.push(new Date(date).toLocaleDateString());
		data.push(amount);
		summaryData.push(summary  ? summary : 0);
	});

	const datasets = [data, summaryData];
	return { datasets, labels };
}

export function assetGraphPointsToChartData(points: AssetGraphPoint[]): AssetsGraphData {
	const labels = [] as string[];
	const data = [] as number[];

	points.forEach(({ date, conversionRate }) => {
		labels.push(new Date(date).toLocaleDateString());
		data.push(conversionRate);
	});

	return { labels, data };
}

export function getImageFromBytea(input: any) {
	const binary = [];
	for (let i = 0; i < input.length / 2; i++) {
		const h = input.substr(i * 2, 2);
		binary[i] = parseInt(h, 16);
	}
	const byteArray = new Uint8Array(binary);
	const img = window.URL.createObjectURL(new Blob([byteArray], { type: 'application/octet-stream' }));
	return img;
}

export function getFileFromHex(input: any) {
	const byteArray = new Uint8Array(input.content.length/2);
	for (let x = 0; x < byteArray.length; x++){
		byteArray[x] = parseInt(input.content.substr(x*2,2), 16);
	}

	return new Blob([byteArray], {type: 'application/' + input.type});
}
